// extracted by mini-css-extract-plugin
export default {"message_link_container":"styles_message_link_container__9wAXI"};